import { defineComponent as _defineComponent } from 'vue'
import { __ } from '@@/bits/intl'
import type { ShareService } from '@@/bits/native_share'
import { buildShareLink, shareLinkOnService } from '@@/bits/native_share'
import OzBox, { OzBoxColors } from '@@/library/v4/components/OzBox.vue'
import OzIconButton, {
  OzIconButtonColorScheme,
  OzIconButtonSizePreset,
} from '@@/library/v4/components/OzIconButton.vue'
import type { OzMenuRowsRow } from '@@/library/v4/components/OzMenuRows.vue'
import OzMenuRows, { OzMenuRowsFocusStyle, OzMenuRowsSizePreset } from '@@/library/v4/components/OzMenuRows.vue'
import OzScreenSizeAwareSideModal from '@@/library/v4/components/OzScreenSizeAwareSideModal.vue'
import { useSurfaceStore } from '@@/pinia/surface'
import { useWhiteboardStore } from '@@/pinia/whiteboard'
import { useWindowSizeStore } from '@@/pinia/window_size'
import SurfacePanelHeader from '@@/vuecomponents/SurfacePanelHeader.vue'
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

interface Group {
  name: string
  rows: OzMenuRowsRow<ShareService>[]
}


export default /*#__PURE__*/_defineComponent({
  __name: 'WhiteboardFrameShareViaAnotherAppPanel',
  setup(__props) {

const { isSmallerThanTabletPortrait, isSmallerThanDesktop } = storeToRefs(useWindowSizeStore())
const { links, publicKey, title, description, backgroundLuminance } = storeToRefs(useSurfaceStore())
const whiteboardStore = useWhiteboardStore()

const actionListGroups = computed((): Group[] => {
  const group1Rows: OzMenuRowsRow<ShareService>[] = [
    {
      icon: 'mail_outline',
      text: __('Email'),
      eventPayload: 'email',
    },
  ]

  const group2Rows: OzMenuRowsRow<ShareService>[] = [
    {
      icon: 'facebook_outline',
      text: __('Facebook'),
      eventPayload: 'facebook',
    },
    {
      icon: 'x_logo',
      text: __('Twitter'),
      eventPayload: 'twitter',
    },
    {
      icon: 'google_classroom',
      text: __('Google Classroom'),
      eventPayload: 'googleClassroom',
    },
    {
      icon: 'zoom',
      text: __('Zoom'),
      eventPayload: 'zoom',
    },
  ]

  return [
    {
      name: 'group1',
      rows: group1Rows,
    },
    {
      name: 'group2',
      rows: group2Rows,
    },
  ]
})

const getShareLinkFor = (service: ShareService): string => {
  const url = whiteboardStore.getLinkToFrame(whiteboardStore.panelFrameId!)

  return buildShareLink({
    service,
    ...{
      url,
      title: service === 'email' ? __('Check out my beautiful sandbox on Padlet') : title.value,
      description: service === 'email' ? url : description.value ?? '',
      media: links.value.snap,
      publicKey: publicKey.value,
    },
  })
}

const handleAction = async (_event: unknown, service: ShareService) => {
  shareLinkOnService(getShareLinkFor(service), service)
}

const closePanel = () => {
  whiteboardStore.xFrameShareViaAnotherAppPanel = false
}

return { __sfc: true,isSmallerThanTabletPortrait, isSmallerThanDesktop, links, publicKey, title, description, backgroundLuminance, whiteboardStore, actionListGroups, getShareLinkFor, handleAction, closePanel, __, OzBox, OzBoxColors, OzIconButton, OzIconButtonColorScheme, OzIconButtonSizePreset, OzMenuRows, OzMenuRowsFocusStyle, OzMenuRowsSizePreset, OzScreenSizeAwareSideModal, SurfacePanelHeader }
}

})